import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
// eslint-disable-next-line import/order
import { UZURV_REST_CONFIGURATION, UzurvRestConfiguration, UzurvRestService } from '@uzurv/http';
import { Deserialize } from 'cerialize';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { RefusalReason } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class RefusalReasonService extends UzurvRestService {
  readonly resourceUrl = 'refusalReasons/';

  constructor(
    httpClient: HttpClient,
    @Inject(UZURV_REST_CONFIGURATION)
    protected uzurvRestConfiguration: UzurvRestConfiguration,
    domSanitizer: DomSanitizer
  ) {
    super(httpClient, uzurvRestConfiguration, domSanitizer);
  }

  /**
   * Lists refusal reasons
   *
   */
  listRefusalReasons(): Observable<Array<RefusalReason>> {
    return this.get(`${this.resourceUrl}`, {
      pageNumber: 0,
      pageSize: 100
    }).pipe(map(response => Deserialize(response, RefusalReason)));
  }

  protected getApiUrl(): string {
    return this.uzurvRestConfiguration.dotsApiUrl;
  }
}
